export interface FilterOption {
  name: string;
  /** Optional colour swatch (channels have one, countries don't). */
  color?: string;
}

interface FilterProps {
  label: string;
  options: FilterOption[];
  selected: string[];
  total: number;
  isOpen: boolean;
  scroll?: boolean;
  onToggleOpen: () => void;
  onClose: () => void;
  onToggleOption: (name: string) => void;
  onToggleAll: () => void;
}

export function Filter({
  label,
  options,
  selected,
  total,
  isOpen,
  scroll,
  onToggleOpen,
  onClose,
  onToggleOption,
  onToggleAll,
}: FilterProps) {
  const allSelected = selected.length === total;
  const summary = allSelected ? 'Alle' : `${selected.length} von ${total}`;
  const allLabel = allSelected ? 'Alle abwählen' : 'Alle auswählen';

  return (
    <div className="cw-filter">
      <button className="cw-filter-trigger" onClick={onToggleOpen}>
        <span className="k">{label}</span>
        <span className="v">{summary}</span>
        <span className="caret">▼</span>
      </button>
      {isOpen && (
        <>
          <div className="cw-filter-backdrop" onClick={onClose} />
          <div className={`cw-filter-menu${scroll ? ' scroll' : ''}`}>
            <button className="cw-filter-all" onClick={onToggleAll}>
              {allLabel}
            </button>
            {options.map((o) => {
              const checked = selected.includes(o.name);
              return (
                <button key={o.name} className="cw-filter-opt" onClick={() => onToggleOption(o.name)}>
                  <span className={`cw-check${checked ? ' on' : ''}`}>{checked ? '✓' : ''}</span>
                  {o.color && <span className="cw-swatch" style={{ background: o.color }} />}
                  <span>{o.name}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
